// URLS
export const API_MPX_SIGNIN = "/api/mpx/signIn"
export const API_MPX_SIGNOUT = "/api/mpx/signOut"
export const API_MPX_AUTHORIZE = "/api/mpx/authorize"
export const API_MPX_REGISTRY = "/api/mpx/registry"
export const SSO_AUTHORIZATION = "/vop/sso/authorization"
export const SSO_TOKEN = "/vop/sso/token"
export const SSO_API_TOKEN = "/vop/sso/api-token"
export const SSO_USER_INFO = "/vop/sso/userInfo"
export const API_MPX_ACCOUNT = "/api/mpx/account"



// WEBPACK FOOTER //
// ./src/Auth/urls.js